<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Documentos Acreditación"
          :directory="directory"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          
        </div>
      </div>
      <div class="col-md-12">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  
  props: {
    evalTestId: String,
  },
  data() {
    return {
      icon: "settings",
      tabsHorizontal: [
        {
          icon: "briefcase",
          name: "Documentación",
          component: "document-history-dat",
          permission: "",
        },
        {
          icon: "send",
          name: this.$t("Alcances Registrados"),
          component: "scopes-evaluator-indexx",
          permission: "",
        },
      ],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      
    };
  },
  
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview
        ? this.$store.state.evaluatorReview.evalTest
        : null;
    },
    directory() {
      return this.evalTest.id
        ? this.evalTest.type == "E"
          ? "Evaluación In Situ/Remota"
          : "Testificación"
        : "";
    },
  },
  created() {
    this.$store.state.evaluatorReview.evalTestId = this.evalTestId;
    this.data();
    this.getActivity();
  },
  methods: {
    returnPage() {
      window.location.href =
        "/evaluationTeam/accreditationDocuments?tab=Documentos%20Acreditación";
    },
    data() {
      this.$store.dispatch("getEvalTest");
    },
    
    getActivity() {
      axios
        .get(
          `/evaluator/documentaryEvaluation/activity/${this.$store.state.evaluatorReview.evalTestId}`
        )
        .then((res) => {
          this.$store.state.accreditation.id = res.data.id;
          this.$store.state.accreditation.app = res.data;
        });
    },
    
  },
};
</script>
